export const UPDATE_BID_PROFILE = 'UPDATE_BID_PROFILE';
export const UPDATE_BID_PROFILE_OBJECTS = 'UPDATE_BID_PROFILE_OBJECTS';
export const RESET_BID_PROFILE = 'RESET_BID_PROFILE';

/** Bidding info selection */
export const UPDATE_BIDDING_INFORMATION = 'UPDATE_BIDDING_INFORMATION';
export const UPDATE_ORIGINAL_BIDDING_INFORMATION = 'UPDATE_ORIGINAL_BIDDING_INFORMATION';

/** Schedule selection */
export const UPDATE_SCHEDULE_SELECTION = 'UPDATE_SCHEDULE_SELECTION';
export const CHECK_SCHEDULE_ITEM = 'CHECK_SCHEDULE_ITEM';
export const CHECK_ALL_SCHEDULE_ITEM = 'CHECK_ALL_SCHEDULE_ITEM';
export const CHECK_WORKPLAN_SCHEDULE_ITEM = 'CHECK_WORKPLAN_SCHEDULE_ITEM';
export const CHECK_ALL_WORKPLAN_SCHEDULE_ITEM = 'CHECK_ALL_WORKPLAN_SCHEDULE_ITEM';
export const UPDATE_SCHEDULE_SELECTION_SELECTED_WORKPLAN = 'UPDATE_SCHEDULE_SELECTION_SELECTED_WORKPLAN';
export const UPDATE_ORIGINAL_SCHEDULE_SELECTION = 'UPDATE_ORIGINAL_SCHEDULE_SELECTION';

/** Employee selection */
export const UPDATE_EMPLOYEES_SELECTION = 'UPDATE_EMPLOYEES_SELECTION';
export const UPDATE_ORIGINAL_EMPLOYEES_SELECTION = 'UPDATE_ORIGINAL_EMPLOYEES_SELECTION';

/** Schedule periods */
export const UPDATE_BID_PROFILE_SCHEDULE = 'UPDATE_BID_PROFILE_SCHEDULE';
export const UPDATE_ORIGINAL_BID_PROFILE_SCHEDULE = 'UPDATE_ORIGINAL_BID_PROFILE_SCHEDULE';
